<script setup lang="ts">
import { defineEmits, defineProps } from "vue";
import { useI18n } from "vue-i18n";
import { PropType } from "@vue/runtime-core";
import { AddonsItemStruct } from "@/struct/AddonsStruct";
import AddonsMainItem from "@/components/addons/AddonsMainItem.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { useRouter } from "vue-router";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";

const router = useRouter();

const { t } = useI18n();

defineProps({
  options: {
    type: Object as PropType<AddonsItemStruct[]>,
    required: true,
  },
});

const emits = defineEmits(["action"]);

const goToAddons = () => {
  router.push("/addons");
};

const goToSpecificAddon = (item: AddonsItemStruct) => {
  console.log(item);
  emits("action", item);
};
</script>

<template>
  <div class="addons-main">
    <div class="addons-main__wrapper">
      <div class="addons-main__header">
        <div class="addons-main__header-title h3">
          <span>{{ t("addons.page.connectedOptions") }}</span>
        </div>
        <button
          v-if="options.length > 2"
          class="addons-main__header-add button-small"
          @click="goToAddons"
        >
          <span>{{ t("common.actions.add") }}</span>
          <BaseFigureForIcon
            icon="plus"
            color="secondary"
            size="small"
            is-button
          />
        </button>
      </div>

      <div class="addons-main__list desktop">
        <swiper
          class="addons-main__list-swiper"
          :slides-per-view="3"
          :space-between="10"
          :centered-slides="false"
        >
          <swiper-slide v-for="(item, index) in options" :key="index">
            <AddonsMainItem :option="item" @click="goToSpecificAddon(item)" />
          </swiper-slide>
          <swiper-slide>
            <AddonsMainItem is-addition @click="goToAddons" />
          </swiper-slide>
        </swiper>
      </div>
      <div class="addons-main__list mobile">
        <div
          v-for="(item, index) in options"
          :key="index"
          class="addons-main__list-item"
        >
          <AddonsMainItem :option="item" @click="goToSpecificAddon(item)" />
        </div>
        <div class="addons-main__list-item">
          <AddonsMainItem is-addition @click="goToAddons" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/style/main";

.addons-main {
  width: 100%;
  border-radius: 32px;
  background-color: var(--color-white);

  @media (max-width: 768px) {
    background-color: transparent;
  }

  &__wrapper {
    margin-bottom: 24px;
    width: 100%;
    max-width: 100%;
  }

  &__header {
    margin: 16px 24px 24px 24px;
    padding-top: 8px;
    padding-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 768px) {
      display: none;
    }

    &-add {
      border-radius: 12px;
      gap: 8px;
      padding: 6px 12px;
      background-color: var(--color-bg-primary);
      border: none;
      align-items: center;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
    }
  }

  &__list {
    width: 100%;

    &.desktop {
      display: block;
    }

    &.mobile {
      display: none;
    }

    @media (max-width: 768px) {
      &.desktop {
        display: none;
      }

      &.mobile {
        display: flex;
        flex-flow: column;
        gap: 12px;
      }
    }

    &-swiper {
      padding: 0 24px;
      width: 100%;
    }
  }
}
</style>
